module.exports = __webpack_public_path__ + "static/media/pills.ab0c2d36.svg";